//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import diffTable from './diffTable.vue';
import { getValue } from './diff';
const keys = ({ from, to }) => {
  const newVal = from || {};
  const oldVal = to || {};
  const keys = [...new Set([...Object.keys(oldVal || {}), ...Object.keys(newVal || {})])];
  const arr = keys.sort(function (s, t) {
    const a = s.toLowerCase();
    const b = t.toLowerCase();
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  });
  return { keys: arr, list: [oldVal, newVal] };
};
const visibleScope = ['个人', '本岗', '本岗及下属', '全部'];
const getAction = (action) => {
  return action
    .split(',')
    .reduce((pre, cur) => {
      if (isNaN(Number(cur))) {
        return [...pre, cur];
      }
      return pre;
    }, [])
    .join(',');
};
export default {
  components: {
    diffTable,
  },
  props: {
    scene: {
      type: String,
      default: 'diff', // diff: 差异展示 detail: 详情
    },
    type: {
      type: String,
      default: 'json',
    },
    data: {
      type: Object,
      default: () => {
        return {
          from: {},
          to: {},
          action: 3,
        };
      },
    },
  },
  data() {
    return {
      sync_id: '',
      disabled: true,
      apiActionOptions: [
        { label: 'RPC', value: 'RPC' },
        { label: 'GET', value: 'GET' },
        { label: 'POST', value: 'POST' },
        { label: 'PUT', value: 'PUT' },
        { label: 'DELETE', value: 'DELETE' },
      ],
    };
  },
  computed: {
    bgcColor() {
      switch (`${this.data.action}`) {
        case '0': // 新增
        case 'CREATE': // 新增
          return '#7FF20B';
        case 'MODIFY': // 修改diff
        case '1': // 修改
          return '#f8c01f';
        case 'DELETE': // 删除
        case '2': // 删除
          return '#e53e31';
      }
      return 'none';
    },
    diffData() {
      // 详情
      if (this.scene === 'detail') {
        let visible = '';
        switch (this.type) {
          case 'json':
            return [this.data];
          case 'table':
            return this.data;
          case 'object':
            this.data.action.split(',').forEach((item) => {
              if (!isNaN(Number(item))) {
                visible = visibleScope[item - 1] || '';
              }
            });
            return [
              {
                value: getAction(this.data.action),
                visible,
                filter: this.data.data_filter || '',
              },
            ];
          case 'api':
            return [this.data.action.split(',')];
          case 'object_field':
            return [getAction(this.data.action)];
          case 'element':
          case 'menu':
            return [this.data.action === 'view'];
          default:
            return [this.data];
        }
      }
      let fromVisible = '';
      let toVisible = '';
      // 差异展示
      switch (this.type) {
        case 'json':
          return [this.data.to, this.data.from];
        case 'table':
          return keys(this.data);
        case 'object':
          this.data.from.split(',').forEach((item) => {
            if (!isNaN(Number(item))) {
              fromVisible = visibleScope[item - 1] || '';
            }
          });
          this.data.to.split(',').forEach((item) => {
            if (!isNaN(Number(item))) {
              toVisible = visibleScope[item - 1] || '';
            }
          });
          return [
            {
              value: getAction(this.data.to),
              visible: toVisible,
              filter: this.data.to_filter || '',
            },
            {
              value: getAction(this.data.from),
              visible: fromVisible,
              filter: this.data.from_filter || '',
            },
          ];
        case 'api':
          return [this.data.to.split(','), this.data.from.split(',')];
        case 'object_field':
          return [getAction(this.data.to), getAction(this.data.from)];
        case 'element':
        case 'menu':
          return [this.data.to === 'view', this.data.from === 'view'];
        default:
          return [this.data.to, this.data.from];
      }
    },
    actionOptions() {
      switch (this.type) {
        case 'object_field':
          return [
            { label: '查询', value: 'select' },
            { label: '新增', value: 'insert' },
            { label: '更新', value: 'update' },
          ];
      }
      return [
        { label: '查询', value: 'select' },
        { label: '新增', value: 'insert' },
        { label: '更新', value: 'update' },
        { label: '删除', value: 'delete' },
      ];
    },
  },
  methods: {
    consoleData() {
      console.log(this);
    },
    tableKeys(obj) {
      return Object.keys(obj).filter((key) => {
        return !['tier'].includes(key);
      });
    },
    getValue(val) {
      return getValue(val);
    },
  },
};
